import React, { createContext, useCallback, useState } from 'react'

interface SearchBurnContextValue {
  burnUserBalance: boolean
  setBurnUserBalance: (apply: boolean) => void
  pointsToBurn: number | undefined
  setPointsToBurn: (points: number | undefined) => void
}

const SearchBurnContext = createContext<SearchBurnContextValue>({
  burnUserBalance: false,
  setBurnUserBalance: () => {},
  pointsToBurn: undefined,
  setPointsToBurn: () => {},
})

interface Props {
  children: React.ReactNode
}

export function SearchBurnProvider({ children }: Props) {
  const [burnUserBalance, setBurnUserBalanceState] = useState(false)
  const [pointsToBurn, setPointsToBurnState] = useState<number | undefined>(undefined)

  const setBurnUserBalance = useCallback((apply: boolean) => {
    setBurnUserBalanceState(apply)
  }, [])

  const setPointsToBurn = useCallback((points: number | undefined) => {
    setPointsToBurnState(points)
  }, [])

  return (
    <SearchBurnContext.Provider value={{ burnUserBalance, setBurnUserBalance, pointsToBurn, setPointsToBurn }}>
      {children}
    </SearchBurnContext.Provider>
  )
}

export default SearchBurnContext
